<template>
  <div class="generate">
    <van-nav-bar
      title=""
      :border="false"
    ><template slot="title">
      <strong>三咖音乐代理创建</strong>
    </template>
    <template #left>
      <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.replace('/me')"></span>
    </template>
    </van-nav-bar>

    <div class="form">
      <div class="input"><input ref="mobile" v-model="phone" type="number" placeholder="请输入要绑定的代理的手机号码" @input="limitNum($refs.mobile, 'phone', 11)"></div>
      <van-button color="#169bd5" class="login-btn mt-24 border-radius-10" @click="checkAgent">开始验证</van-button>
    </div>
  </div>
</template>

<script>
import { checkGenerateAgent } from '@/api/agent.js'
import LimitNum from '@/mixins/number-limit.js'
export default {
  name: 'GenerateAgent',
  mixins: [LimitNum],
  data() {
    return {
      phone: '' // 电话号码
    }
  },
  methods: {
    async checkAgent() {
      this.$store.commit('TOGGLE_LOADING', true)
      try {
        const res = await checkGenerateAgent({ phone: this.phone })
        if (res.code === 1) {
          localStorage.setItem('generateAgentUsreInfo', JSON.stringify({ ...res.data, phone: this.phone }))
          setTimeout(() => {
            this.$router.push('/agent/check-success')
          }, 50)
        }
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.generate{
  height: 100vh;
  overflow: hidden;
  background-image: linear-gradient(45deg, #a0d7ec, #eee );
}
.form{
  height: calc(100vh - 47px);
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: cetner;
  padding: 0 20px;
}
.input{
  display: flex;
  align-items: center;
  input{
    display: block;
    line-height: inherit;
    background-color: #fff;
    border-radius: 25px;
    width: 100%;
    height: 55px;
    line-height: 55px;
    text-indent: 15px;
  }
}
.border-radius-10{
  border-radius: 10px;
}
</style>
